// Muxum header: megamenu open/close + mobile drawer + cart toggle dispatch.
(() => {
  const header = document.querySelector('[data-muxum-header]');
  if (!header) return;

  // ---- Megamenus ----------------------------------------------------------
  const triggers = header.querySelectorAll('[data-muxum-menu-trigger]');
  const panels = header.querySelectorAll('[data-muxum-menu-panel]');
  const panelByName = new Map();
  panels.forEach((p) => panelByName.set(p.dataset.muxumMenuPanel, p));

  let openName = null;
  let hoverTimer = null;

  const openMenu = (name) => {
    if (openName === name) return;
    closeMenu();
    const panel = panelByName.get(name);
    if (!panel) return;
    panel.hidden = false;
    // force reflow so the transition fires
    void panel.offsetWidth;
    panel.dataset.open = 'true';
    triggers.forEach((t) => {
      if (t.dataset.muxumMenuTrigger === name) t.setAttribute('aria-expanded', 'true');
    });
    openName = name;
  };

  const closeMenu = () => {
    if (!openName) return;
    const panel = panelByName.get(openName);
    if (panel) {
      panel.dataset.open = 'false';
      // wait for transition before hiding
      setTimeout(() => {
        if (panel.dataset.open === 'false') panel.hidden = true;
      }, 200);
    }
    triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
    openName = null;
  };

  triggers.forEach((trigger) => {
    const name = trigger.dataset.muxumMenuTrigger;
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (openName === name) closeMenu();
      else openMenu(name);
    });
    trigger.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(() => openMenu(name), 80);
    });
    trigger.addEventListener('mouseleave', () => {
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(() => {
        const hovered = document.querySelector('[data-muxum-menu-panel]:hover');
        if (!hovered) closeMenu();
      }, 200);
    });
  });

  panels.forEach((panel) => {
    panel.addEventListener('mouseleave', () => {
      hoverTimer = setTimeout(closeMenu, 200);
    });
    panel.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimer);
    });
  });

  // ESC + outside click
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeMenu();
      closeMobile();
    }
  });
  document.addEventListener('click', (e) => {
    if (!header.contains(e.target)) closeMenu();
  });

  // ---- Mobile drawer ------------------------------------------------------
  const mobileToggle = header.querySelector('[data-muxum-mobile-toggle]');
  const mobileDrawer = document.querySelector('[data-muxum-mobile-drawer]');
  const mobileOverlay = document.querySelector('[data-muxum-mobile-overlay]');
  const mobileClose = document.querySelector('[data-muxum-mobile-close]');

  const openMobile = () => {
    if (!mobileDrawer || !mobileOverlay) return;
    mobileDrawer.hidden = false;
    mobileOverlay.hidden = false;
    void mobileDrawer.offsetWidth;
    mobileDrawer.dataset.open = 'true';
    mobileOverlay.dataset.open = 'true';
    mobileToggle?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  };

  const closeMobile = () => {
    if (!mobileDrawer || !mobileOverlay) return;
    mobileDrawer.dataset.open = 'false';
    mobileOverlay.dataset.open = 'false';
    mobileToggle?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(() => {
      if (mobileDrawer.dataset.open === 'false') {
        mobileDrawer.hidden = true;
        mobileOverlay.hidden = true;
      }
    }, 250);
  };

  mobileToggle?.addEventListener('click', openMobile);
  mobileClose?.addEventListener('click', closeMobile);
  mobileOverlay?.addEventListener('click', closeMobile);

  // ---- Cart toggle (dispatches event for cart drawer) ---------------------
  const cartBtn = header.querySelector('[data-muxum-cart-toggle]');
  cartBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    document.dispatchEvent(new CustomEvent('muxum:cart:open'));
  });

  // ---- Cart count updates from Cart AJAX events ---------------------------
  const updateCount = (count) => {
    header.querySelectorAll('[data-muxum-cart-count]').forEach((el) => {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  };
  document.addEventListener('muxum:cart:updated', (e) => {
    if (typeof e.detail?.itemCount === 'number') updateCount(e.detail.itemCount);
  });
})();
